import React from 'react';

import { Stack, Typography } from '@mui/material';
import { RouteList } from 'types';

import notFoundSvg from '../../../assets/404.svg';
import { RouterLinkButton } from 'components';

export const UnexpectedError = () => {
  return (
    <>
      <img alt="Unerwarteter Fehler" style={{ maxHeight: 180 }} src={notFoundSvg} />
      <Stack spacing={2} alignItems="center">
        <Typography variant="h1" textAlign="center">
          Ups, da ist etwas schiefgelaufen
        </Typography>
        <Typography sx={{ maxWidth: '500px' }} variant="body2" textAlign="center">
          Bitte versuche es später noch einmal. Wenn das Problem weiterhin besteht, melde dich gerne bei unserem
          Support.
        </Typography>
      </Stack>
      <RouterLinkButton to={RouteList.MyCampaigns} color="primary" variant="contained">
        Zu meinen Kampagnen
      </RouterLinkButton>
      <RouterLinkButton variant="outlined" to={RouteList.Contact}>
        Zum support
      </RouterLinkButton>
    </>
  );
};
